// Hand-drawn, pastel course illustrations to match the PBL & Inquiry Learning artwork
const S = { stroke: "#29243B", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" };

const Science = () => (
  <>
    <circle cx="70" cy="70" r="34" fill="#FFFFFF" opacity=".55" />
    <path d="M150 30h28M155 30v34l-30 62q-5 12 9 12h60q14 0 9-12l-30-62V30" fill="#FFFFFF" {...S} />
    <path d="M135 104q14-8 28 0t32-2l10 22q5 12-9 12h-60q-14 0-9-12z" fill="#DCCBFA" {...S} />
    <circle cx="160" cy="88" r="4" fill="#F9D9DB" {...S} />
    <circle cx="170" cy="70" r="3" fill="none" {...S} />
    <path d="M52 140c0-20 10-34 24-40M76 100c10 6 14 18 10 28M64 112c-10-2-18 2-22 10" fill="none" {...S} />
    <path d="M76 100c-4-10-14-14-22-12c2 10 10 14 22 12z" fill="#BCEBD7" {...S} />
    <path d="M76 100c6-9 16-11 24-7c-4 9-14 11-24 7z" fill="#BCEBD7" {...S} />
    <path d="M40 140h60" {...S} />
    <path d="M230 40l4 10l10 4l-10 4l-4 10l-4-10l-10-4l10-4z" fill="#FFE58C" {...S} />
  </>
);

const Social = () => (
  <>
    <circle cx="150" cy="78" r="46" fill="#BCEBD7" {...S} />
    <path d="M120 60q14-16 30-6q6 10-6 18q-14 6-24-12z" fill="#FFFFFF" {...S} />
    <path d="M156 84q18-8 26 6q-3 18-22 16q-12-10-4-22z" fill="#FFFFFF" {...S} />
    <ellipse cx="150" cy="78" rx="20" ry="46" fill="none" {...S} strokeOpacity=".45" />
    <path d="M150 124v14M124 140h52" {...S} />
    <path d="M42 140v-34l22-18l22 18v34z" fill="#F9D9DB" {...S} />
    <path d="M56 140v-16h16v16" fill="#FFFFFF" {...S} />
    <path d="M230 140c0-18 8-28 0-44c-8 16 0 26 0 44z" fill="#BCEBD7" {...S} />
    <path d="M222 140h16" {...S} />
    <path d="M226 34c-6-8-18-2-12 8l12 10l12-10c6-10-6-16-12-8z" fill="#F9D9DB" {...S} />
  </>
);

const Thinking = () => (
  <>
    <path d="M150 24c-22 0-36 15-36 34c0 13 8 21 13 26c5 5 6 9 6 14h34c0-5 1-9 6-14c5-5 13-13 13-26c0-19-14-34-36-34z" fill="#FFE58C" {...S} />
    <path d="M136 110h28M140 120h20M142 64l8 8l8-8M150 72v24" {...S} />
    <path d="M96 36l-12-6M204 36l12-6M110 12l-6-8M190 12l6-8" {...S} />
    <path d="M40 92q0-18 22-18h26q20 0 20 18t-20 18h-14l-14 12v-12q-20 0-20-18z" fill="#FFFFFF" {...S} />
    <path d="M60 92h2M74 92h2M88 92h2" {...S} strokeWidth="4" />
    <path d="M206 110q0-14 16-14h14q16 0 16 14t-16 14h-4l-10 10v-10q-16 0-16-14z" fill="#DCCBFA" {...S} />
    <path d="M228 104c0-6 10-6 10 0c0 4-5 4-5 9M233 118v1" {...S} />
  </>
);

const Filter = () => (
  <>
    <path d="M110 20h80l-12 40h-56z" fill="#FFFFFF" {...S} />
    <path d="M116 34h68" {...S} strokeDasharray="4 6" />
    <path d="M122 60h56v40q0 12-12 12h-32q-12 0-12-12z" fill="#FFE58C" {...S} />
    <path d="M122 76h56M122 92h56" {...S} strokeOpacity=".6" />
    <path d="M150 112v14" {...S} />
    <path d="M150 128q-6 8 0 12q6-4 0-12z" fill="#DCCBFA" {...S} />
    <path d="M60 140c0-26 10-40 26-48M86 92c10 6 12 18 8 30" fill="none" {...S} />
    <path d="M86 92c-4-10-14-14-22-12c2 10 10 14 22 12z" fill="#BCEBD7" {...S} />
    <path d="M230 50l4 10l10 4l-10 4l-4 10l-4-10l-10-4l10-4z" fill="#F9D9DB" {...S} />
    <path d="M40 150h220" {...S} />
  </>
);

const Engineering = () => (
  <>
    <circle cx="112" cy="70" r="26" fill="#FFFFFF" {...S} />
    <circle cx="112" cy="70" r="9" fill="#FFE58C" {...S} />
    <path d="M112 36v-8M112 112v-8M78 70h-8M154 70h-8M88 46l-6-6M142 100l-6-6M136 46l6-6M82 100l6-6" {...S} strokeWidth="5" />
    <circle cx="160" cy="104" r="16" fill="#BCEBD7" {...S} />
    <circle cx="160" cy="104" r="5" fill="#FFFFFF" {...S} />
    <path d="M160 82v-4M160 130v-4M138 104h-4M186 104h-4" {...S} strokeWidth="5" />
    <path d="M200 140v-40h70v40M200 100l17 40M217 100l18 40M235 100l17 40M200 100l35-28l35 28" fill="none" {...S} />
    <path d="M30 140h250" {...S} />
    <path d="M44 140l14-28l14 28z" fill="#F9D9DB" {...S} />
    <path d="M250 40l4 10l10 4l-10 4l-4 10l-4-10l-10-4l10-4z" fill="#FFE58C" {...S} />
  </>
);

const ART = { "science-inquiry": Science, "social-studies": Social, engineering: Engineering, "critical-thinking": Thinking, filter: Filter };

export const CourseArt = ({ name, className = "" }) => {
  const Art = ART[name];
  return (
    <svg viewBox="0 0 300 160" className={className} aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">
      <Art />
    </svg>
  );
};
